import type {RepoSubject, SubjectType} from '@github-ui/comment-box/subject'
import {useLayoutPullRequest} from '@github-ui/pull-requests/layout-selectors'
import type {DiffRange} from '../../types'

type PullRequestCommentBoxSurface = 'review' | 'issue_comment' | 'description'

function surfaceToSubjectType(surface: PullRequestCommentBoxSurface): SubjectType {
  switch (surface) {
    case 'review':
      return 'pull_request'
    case 'issue_comment':
      return 'pull_request_comment'
    case 'description':
      return 'pull_request_body'
  }
}

interface UseCommentBoxSubjectOptions {
  surface: PullRequestCommentBoxSurface
  comparisonRange?: DiffRange
}

export function useCommentBoxSubject({surface, comparisonRange}: UseCommentBoxSubjectOptions): RepoSubject {
  const pullRequest = useLayoutPullRequest()
  const repository = pullRequest.baseRepository
  return {
    type: surfaceToSubjectType(surface),
    id: pullRequest.relayId ? {id: pullRequest.relayId, databaseId: pullRequest.id} : undefined,
    pullRequestNumber: pullRequest.number,
    repository: {
      databaseId: repository.id,
      nwo: `${repository.ownerLogin}/${repository.name}`,
      slashCommandsEnabled: repository.slashCommandsEnabled ?? false,
    },
    comparison: comparisonRange
      ? {
          startCommitOid: comparisonRange.baseOid,
          endCommitOid: comparisonRange.headOid,
        }
      : undefined,
  }
}
